<template>
  <div class="LoyaltyFeature">
    <div class="LoyaltyFeature__info">
      <div class="header">
        <h4 class="sub-heading">( Join Members Only Now )</h4>
        <h3 class="heading">Have {{ bonus }}, From Us, To You</h3>
      </div>
      <p class="text">{{ text }}</p>

      <Picture class="image" :images="imageOne" />
    </div>
    <div class="LoyaltyFeature__focus">
      <Picture class="centered-image" :images="imageTwo" />
      <button class="LoyaltyFeature__button">
        Sign up to claim your 400 Style Points
      </button>
    </div>
  </div>
</template>

<script>
import Picture from "@/components/Picture.vue";
import { signUpBonus } from "@/config";
import { mapGetters } from "vuex";
export default {
  name: "LoyaltyFeature",
  components: {
    Picture,
  },
  props: {
    imageOne: {
      type: Object,
      required: true,
    },
    imageTwo: {
      type: Object,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters("app", ["currencyCode"]),
    bonus() {
      if (!this.currencyCode) {
        return null;
      }

      const amount = signUpBonus[this.currencyCode];
      return this.$filters.toCurrency(amount, this.currencyCode, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.LoyaltyFeature {
  display: grid;
  grid-template-columns: 1fr;

  @include respond-above(md) {
    grid-template-columns: repeat(2, 1fr);
  }

  &__info {
    position: relative;
  }

  &__focus {
    align-items: center;
    display: flex;
    background-image: url("https://cdn.shopify.com/s/files/1/0942/9062/files/loyalty-texture.jpg");
    background-position: center center;
    background-size: cover;
    flex-direction: column;
    padding: 80px 0;
    justify-content: center;
    position: relative;
    width: 100%;

    @include respond-above(md) {
      padding: 0;
    }
  }
  &__button {
    color: $color-white;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.55px;
    outline: none;
    background: none;
    border: none;
    padding: 0;
    text-transform: uppercase;
  }
}

.header {
  position: absolute;
  text-align: center;
  top: 40px;
  width: 100%;
  z-index: 1;

  @include respond-above(md) {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    top: 0;
  }
}

.heading {
  color: $color-white;
  font-size: 28px;
  font-weight: 400;
  text-transform: uppercase;
  z-index: 1;

  @include respond-above(md) {
    font-size: 70px;
    margin: 0 auto;
    max-width: 90%;
  }
}

.sub-heading {
  color: $color-white;
  font-family: $heading-font-family;
  font-size: 12px;
  font-weight: 400;

  @include respond-above(md) {
    font-size: 18px;
  }
}

.text {
  color: $color-white;
  bottom: 40px;
  font-family: $heading-font-family;
  font-weight: 300;
  padding: 0 20px;
  position: absolute;
  text-align: center;
  width: 100%;
  z-index: 1;

  @include respond-above(md) {
    font-size: 18px;
  }
}

.centered-image {
  margin: 0 0 15px 0;
  max-width: 60%;
  @include respond-above(md) {
    margin: 0 0 20px 0;
  }
}
</style>
